/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../resources/datatypes';
import './transaction_info';
import '../resources/enums';
import '../../resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "merchant_catalog": {
                "nested": {
                  "service": {
                    "nested": {
                      "BatchUpsertCatalogObjectsRequest": {
                        "fields": {
                          "idempotencyKey": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "batches": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.CatalogObjectBatch",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "transactionInfo": {
                            "type": ".squareup.connect.v2.merchant_catalog.service.TransactionInfo",
                            "id": 3,
                            "rule": "optional"
                          },
                          "ignoreItemDefaults": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.IgnoreItemDefaultsField",
                            "id": 4,
                            "rule": "repeated"
                          }
                        }
                      },
                      "BatchUpsertCatalogObjectsResponse": {
                        "fields": {
                          "errors": {
                            "type": ".squareup.connect.v2.resources.Error",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "objects": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.CatalogObject",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "updatedAt": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "idMappings": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.CatalogIdMapping",
                            "id": 4,
                            "rule": "repeated"
                          },
                          "lockToken": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.BatchUpsertCatalogObjectsRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.BatchUpsertCatalogObjectsResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE BatchUpsertCatalogObjectsRequest @ squareup/connect/v2/catalog/interfaces/batch-upsert-catalog-obj.proto at 21:1
 */
export const BatchUpsertCatalogObjectsRequest = $root.lookupType('squareup.connect.v2.merchant_catalog.service.BatchUpsertCatalogObjectsRequest');
fixType(BatchUpsertCatalogObjectsRequest, {
  idempotencyKey: {
    required: true,
    notEmpty: true
  },
  batches: {
    required: true
  }
});
Builder.createAndAttachToType(BatchUpsertCatalogObjectsRequest);
/**
 * SOURCE BatchUpsertCatalogObjectsResponse @ squareup/connect/v2/catalog/interfaces/batch-upsert-catalog-obj.proto at 80:1
 */
export const BatchUpsertCatalogObjectsResponse = $root.lookupType('squareup.connect.v2.merchant_catalog.service.BatchUpsertCatalogObjectsResponse');
fixType(BatchUpsertCatalogObjectsResponse);
Builder.createAndAttachToType(BatchUpsertCatalogObjectsResponse);